<template>
    <div class="w-14 h-14">
        <img class="w-full h-auto" :src="value" />
    </div>
</template>

<script>
export default {
    props: ['value'],
};
</script>



// WEBPACK FOOTER //
// PreviewImage.vue?2f66a31a